import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchAccionesLiquidaciones } from '../../../../actions/LiquidacionesActions';
import { fetchListaConceptos } from '../../../../actions/tiposActions';
import { putEliminaConceptoFinal, putEditaConceptoFinal, getTiposConceptos, getAccionesLiquidaciones } from '../../../../api/axios';
import { EstiloCombos, DropDownArrow } from '../../../../template/CustomStyle';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { Spinner } from 'react-bootstrap';

// Wrapper para usar hooks en class component
function ListConceptosWrapper(props) {
  const navigate = useNavigate();
  return <ListConceptos {...props} navigate={navigate} />;
}

class ListConceptos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            descripcion: "",
            dropdownSubTipo: {
                idSubTipo: null,
                label: ""
            },
            tiposConceptosLocal: [],
            accionesLocal: []
        }
    };

    componentDidMount() {
        this.props.fetchAccionesLiquidaciones();
        this.props.fetchListaConceptos();
        this.loadLocalFallbackData();
    }

    loadLocalFallbackData = async () => {
        try {
            const conceptosRes = await getTiposConceptos();
            const conceptosRaw = Array.isArray(conceptosRes)
                ? conceptosRes
                : (Array.isArray(conceptosRes?.tiposNovedades)
                    ? conceptosRes.tiposNovedades
                : (Array.isArray(conceptosRes?.listaConceptoNovedades)
                    ? conceptosRes.listaConceptoNovedades
                    : (Array.isArray(conceptosRes?.elementos) ? conceptosRes.elementos : [])));
            const tiposConceptosLocal = conceptosRaw.map((item) => ({
                ...item,
                idConcepto: item?.idConcepto ?? item?.IdConcepto ?? item?.concepto ?? item?.Concepto ?? "",
                detalleConcepto: item?.detalleConcepto ?? item?.DetalleConcepto ?? item?.concepto ?? item?.Concepto ?? "",
                idSubTipo: item?.idSubTipo ?? item?.IdSubTipo ?? item?.idTipoNovedad ?? item?.IdTipoNovedad ?? 0,
                idTipoNovedad: item?.idTipoNovedad ?? item?.IdTipoNovedad ?? item?.idSubTipo ?? item?.IdSubTipo ?? 0,
                descripcionSubTipoNovedad: item?.descripcionSubTipoNovedad ?? item?.DescripcionSubTipoNovedad ?? item?.descripcionSubTipo ?? item?.DescripcionSubTipo ?? "",
                mostrarBotonEliminar: item?.mostrarBotonEliminar ?? item?.MostrarBotonEliminar ?? true
            }));

            const accionesRes = await getAccionesLiquidaciones();
            const accionesRaw = Array.isArray(accionesRes)
                ? accionesRes
                : (Array.isArray(accionesRes?.subTiposNovedades)
                    ? accionesRes.subTiposNovedades
                : (Array.isArray(accionesRes?.listadoNovedadesSubtipo)
                    ? accionesRes.listadoNovedadesSubtipo
                    : (Array.isArray(accionesRes?.elementos) ? accionesRes.elementos : [])));
            const accionesLocal = accionesRaw.map((tipo) => ({
                label: tipo?.descripcion ?? tipo?.Descripcion ?? "",
                value: tipo?.idEstado ?? tipo?.IdEstado ?? tipo?.idSubTipo ?? tipo?.IdSubTipo ?? tipo?.idTipoNovedad ?? tipo?.IdTipoNovedad ?? 0,
            }));

            this.setState({ tiposConceptosLocal, accionesLocal });
        } catch (_) {
            // fallback silencioso
        }
    };

    loadInputs(tipoConcepto) {

        const { detalleConcepto, idSubTipo, descripcionSubTipoNovedad } = tipoConcepto;

        this.setState({ 
            descripcion: detalleConcepto,
            dropdownSubTipo: { 
                ...this.state.dropdownSubTipo, 
                idSubTipo: idSubTipo,
                label: descripcionSubTipoNovedad
            }
        });
    }

    myChangeHandler = async (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    onChangeDropdownSubTipo = async (e) => {

        const { label, value } = e;

        this.setState({ 
            dropdownSubTipo: { 
                ...this.state.dropdownSubTipo, 
                idSubTipo: value,
                label: label
            } 
        });
    }

    editarConcepto = (idConcepto) => {
        const { descripcion, dropdownSubTipo } = this.state;

        let datos = {
            idConcepto: idConcepto,
            idTipoNovedad: dropdownSubTipo.idSubTipo,
            descripcionConcepto: descripcion
        }
        let post = putEditaConceptoFinal(datos);

        post.then(res => {
            this.componentDidMount();
            document.getElementById("title").click();
            toast.success("El concepto fue actualizado con exito");
        }).catch(err => {
            toast.error("No pudimos editar el concepto");
        });
    }

    eliminarConcepto = (idTipoNovedad) => {

        let data = {
            IdTipoNovedad: idTipoNovedad
        };

        let post = putEliminaConceptoFinal(data);

        post.then(res => {
            toast.success(res.data.conceptoAnulado);
            this.componentDidMount();
        }).catch(err => {
            toast.error("No se pudo eliminar el concepto");
        });
    }

    gotoNuevoConcepto = () => {
        this.props.navigate("/Conceptos/Nuevo");
    }

    render() {
        const { lista_acciones_liquidaciones, loadingTipos } = this.props;
        const { descripcion, dropdownSubTipo } = this.state;
        let tiposConceptosRaw = this.props.tiposConceptos;
        let tiposConceptos = Array.isArray(tiposConceptosRaw)
            ? tiposConceptosRaw
            : (Array.isArray(tiposConceptosRaw?.tiposNovedades)
                ? tiposConceptosRaw.tiposNovedades
            : (Array.isArray(tiposConceptosRaw?.listaConceptoNovedades)
                ? tiposConceptosRaw.listaConceptoNovedades
                : (Array.isArray(tiposConceptosRaw?.elementos)
                    ? tiposConceptosRaw.elementos
                    : [])));

        tiposConceptos = tiposConceptos.map((item) => ({
            ...item,
            idConcepto: item?.idConcepto ?? item?.IdConcepto ?? item?.concepto ?? item?.Concepto ?? "",
            detalleConcepto: item?.detalleConcepto ?? item?.DetalleConcepto ?? item?.concepto ?? item?.Concepto ?? "",
            idSubTipo: item?.idSubTipo ?? item?.IdSubTipo ?? item?.idTipoNovedad ?? item?.IdTipoNovedad ?? 0,
            idTipoNovedad: item?.idTipoNovedad ?? item?.IdTipoNovedad ?? item?.idSubTipo ?? item?.IdSubTipo ?? 0,
            descripcionSubTipoNovedad: item?.descripcionSubTipoNovedad ?? item?.DescripcionSubTipoNovedad ?? item?.descripcionSubTipo ?? item?.DescripcionSubTipo ?? "",
            mostrarBotonEliminar: item?.mostrarBotonEliminar ?? item?.MostrarBotonEliminar ?? true
        }));

        let listaAccionesLiquidacion = [];
        const accionesRaw = Array.isArray(lista_acciones_liquidaciones)
            ? lista_acciones_liquidaciones
            : (Array.isArray(lista_acciones_liquidaciones?.subTiposNovedades)
                ? lista_acciones_liquidaciones.subTiposNovedades
            : (Array.isArray(lista_acciones_liquidaciones?.listadoNovedadesSubtipo)
                ? lista_acciones_liquidaciones.listadoNovedadesSubtipo
                : (Array.isArray(lista_acciones_liquidaciones?.elementos)
                    ? lista_acciones_liquidaciones.elementos
                    : [])));

        if (accionesRaw.length > 0) {
            listaAccionesLiquidacion = accionesRaw.map((tipo) => ({
                label: tipo?.descripcion ?? tipo?.Descripcion ?? "",
                value: tipo?.idEstado ?? tipo?.IdEstado ?? tipo?.idSubTipo ?? tipo?.IdSubTipo ?? tipo?.idTipoNovedad ?? tipo?.IdTipoNovedad ?? 0,
            }));
        }

        if (tiposConceptos.length === 0 && this.state.tiposConceptosLocal.length > 0) {
            tiposConceptos = this.state.tiposConceptosLocal;
        }
        if (listaAccionesLiquidacion.length === 0 && this.state.accionesLocal.length > 0) {
            listaAccionesLiquidacion = this.state.accionesLocal;
        }

        const hasDataToRender = tiposConceptos.length > 0;

        return (
            <div className="container">

                <div className="row justify-content-between mb-3">
                        
                    <div className="col-12 col-md-7">
                        <h4 className="text-themecolor color-rojo-megatone">Gestión de Conceptos</h4>
                    </div>

                    <div className="col-12 col-md-3 text-end">
                        <button 
                            type="button" 
                            onClick={this.gotoNuevoConcepto} 
                            className="btn btn-sm btn-green"
                        >
                            <i className="fa fa-plus-circle"/> Crear Concepto
                        </button>
                    </div>

                </div>

                {(loadingTipos && !hasDataToRender) ? (
                    <div className="d-flex justify-content-center">
                        <Spinner animation="border" variant="secondary" size="lg-centrado" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                    </div>

                ) : !hasDataToRender ? (
                
                    <div className="container">
                        <h5 className="d-flex justify-content-center m-t-40 m-b-40">
                            NO SE ENCONTRARON RESULTADOS
                        </h5>
                    </div>

                ) : (

                    <div className="list-group-item col-12 animated fadeIn">
                        <div className="table-responsive card">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Acción</th>
                                        <th>Editar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    tiposConceptos.map((tipoConcepto, i) => {
                                        return (
                                            <tr key={i} className="hover-background-color">
                                                <td><small>{tipoConcepto.idConcepto}</small></td>
                                                <td><small>{tipoConcepto.descripcionSubTipoNovedad}</small></td> 
                                                <td>
                                                {
                                                    tipoConcepto.mostrarBotonEliminar ?
                                                    <div key={i}>

                                                        <OverlayTrigger
                                                            key={`overlay-edit-${i}`}
                                                            trigger="click"
                                                            rootClose={true}
                                                            placement={"top"}
                                                            overlay={
                                                                <Popover id={`popover-edit-${i}`}>

                                                                    <Popover.Header className="text-center" as="h3">
                                                                        ¿Actualizar Concepto?
                                                                    </Popover.Header>
                                                                    
                                                                    <Popover.Body className="row justify-content-center align-items-center">

                                                                        <label className="col-4">Nombre:</label>

                                                                        <div className="col-8">
                                                                            <input 
                                                                                type="text" 
                                                                                name="descripcion"
                                                                                className="form-control" 
                                                                                value={descripcion}
                                                                                onChange={this.myChangeHandler} 
                                                                                maxLength="50"
                                                                            />
                                                                        </div>

                                                                        <label className="col-4 mt-2">Acción:</label>

                                                                        <div className="col-8 mt-2">
                                                                            <Select 
                                                                                className="text-capitalize"
                                                                                styles={EstiloCombos}
                                                                                options={listaAccionesLiquidacion}
                                                                                components={{ DropdownIndicator: () => DropDownArrow }}
                                                                                onChange={this.onChangeDropdownSubTipo}
                                                                                value={{
                                                                                    value: dropdownSubTipo.idSubTipo,
                                                                                    label: dropdownSubTipo.label
                                                                                }}
                                                                            />
                                                                        </div>

                                                                        <div className="mt-3 col-auto">
                                                                            <button 
                                                                                onClick={() => this.editarConcepto(tipoConcepto.idConcepto)}
                                                                                className="btn btn-sm background-rojo-megatone"
                                                                                disabled={descripcion === ""}
                                                                            >
                                                                                Actualizar
                                                                            </button>
                                                                        </div>

                                                                    </Popover.Body>
                                                                </Popover>
                                                            }
                                                        >
                                                            <button 
                                                                type="button" 
                                                                title="Editar" 
                                                                className="btn"
                                                                onClick={() => this.loadInputs(tipoConcepto)}
                                                            >
                                                                <i className="fa fa-clipboard" aria-hidden="true"/>
                                                            </button>
                                                        </OverlayTrigger>

                                                        <OverlayTrigger
                                                            key={`overlay-delete-${i}`}
                                                            trigger="click"
                                                            rootClose={true}
                                                            placement={"top"}
                                                            overlay={
                                                                <Popover id={`popover-delete-${i}`}>
                                                                    <Popover.Header as="h3">
                                                                        ¿Eliminar Concepto?
                                                                    </Popover.Header>
                                                                    <Popover.Body className="row justify-content-center">
                                                                        <button 
                                                                            className="btn btn-sm background-rojo-megatone col-auto"
                                                                            onClick={
                                                                                () => this.eliminarConcepto(tipoConcepto.idTipoNovedad)
                                                                            }
                                                                        >
                                                                            Eliminar
                                                                        </button>
                                                                    </Popover.Body>
                                                                </Popover>
                                                            }
                                                        >
                                                            <button 
                                                                title="Eliminar" 
                                                                type="button" 
                                                                className="btn color-rojo-megatone"
                                                            >
                                                                <i className="fa fa-trash" aria-hidden="true"/>
                                                            </button>
                                                        </OverlayTrigger>

                                                    </div>
                                                    : ""
                                                }
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}


const mapStateToProps = state => ({
    tipoUsuario: state.general.tipoUsuario,
    loadingTipos: state.tipos.loadingTipos,
    tiposConceptos: state.tipos.tipoLiquidacionConcepto,
    lista_acciones_liquidaciones: state.liquidaciones.lista_acciones_liquidaciones
});

export default connect(mapStateToProps, { 
    fetchListaConceptos, 
    fetchAccionesLiquidaciones 
}) (ListConceptosWrapper);